import React, { useEffect, useState } from 'react';

import StarBarRatingItem from './star-bar-rating-item/star-bar-rating-item';

import styles from './star-bar-rating.scss';

export interface RatingSummary {
  count?: number;
  rating: number | string;
}

interface StarBarRatingProps {
  heading?: string;
  noDataMessage?: string;
  ratingSummaries?: RatingSummary[];
  totalCount: number;
}

function sortRatingSummaries(summaries) {
  return [...summaries].sort(
    (a, b) => parseFloat(b?.rating) - parseFloat(a?.rating)
  );
}

function StarBarRating(props: StarBarRatingProps) {
  const { heading, noDataMessage, ratingSummaries, totalCount } = props;

  const [sortedRatingSummaries, setSortedRatingSummaries] = useState<
    RatingSummary[]
  >([]);

  useEffect(() => {
    setSortedRatingSummaries(
      Array.isArray(ratingSummaries) ? sortRatingSummaries(ratingSummaries) : []
    );
  }, [ratingSummaries]);

  return (
    <div className={styles['container']}>
      <div className={styles['by-review']}>
        {heading && <h5 className={styles['section-heading']}>{heading}</h5>}
        {sortedRatingSummaries.length > 0
          ? sortedRatingSummaries.map((ratingSummary, idx) => (
              <StarBarRatingItem
                key={idx}
                ratingSummary={ratingSummary}
                totalCount={totalCount}
              />
            ))
          : noDataMessage && <div>{noDataMessage}</div>}
      </div>
    </div>
  );
}

export { StarBarRatingItem };
export default StarBarRating;
